import React from 'react';
import { Image } from 'react-bootstrap';
import NextStep from '../../../assets/images/campaignStreamline/next_step.png';
import './CustomStepsV2.scss';

const CustomStepsV2 = ({
  stepsConfig,
  stepOnClick,
}) => {
  const stepLength = stepsConfig.length;
  
  if (stepsConfig.find(step => step.active && step.hide)) {
    return (
      <div className='custom-step-content-v2-hide'/>
    )
  }

  return (
    <div
      className={`custom-step-content-v2 ${stepLength === 0 ? 'no-step-content-v2' : ''
        }`}
    >
      {stepsConfig.map((item, index) => {
        const isLastStep = index === stepLength - 1;
        return (
          <div
            key={`${index}-${item.name}`}
            className={`custom-one-step-content-v2 ${isLastStep ? 'custom-last-step-content-v2' : ''}`}
          >
            <div
              className='custom-step-name-container-v2'
              onClick={() => {
                if (item.active) {
                  return;
                };
                stepOnClick(index);
              }}
            >
              <label
                className={`custom-step-name-v2 ${item.active
                  ? 'custom-step-name-v2-actived'
                  : 'custom-step-name-v2-inactive'
                  }`}
              >
                {item.name}
              </label>
            </div>
            {isLastStep
              ? null
              : <div className="custom-step-v2-next-step">
                <Image src={NextStep} className="custom-step-v2-next-step-image" />
              </div>
            }
          </div>
        );
      })}
    </div>
  );
}

export default CustomStepsV2;
